import { NewSuitabilityData } from '../../types';

/**
 * Empty until a client or household is chosen, which the summary reads as nothing to show. Built
 * from optional fields it read "undefined undefined", a truthy string the summary displayed, and a
 * pre-filled flow reaches the summary before its client has resolved.
 */
export function clientLabel(data: NewSuitabilityData): string {
  if (data.isFamily) return data.family ? `${data.family.name} family` : '';
  return data.client ? `${data.client.firstName} ${data.client.lastName}` : '';
}
